import { Activity, ActivityFromJSON } from "../Activity";

export interface ProjectTimeItem {
  period: Date;
  activity: Activity;
  user_id: number;
  user_login: string;
  spent_time: number;
}

export function ProjectTimeItemFromJSON(json: any): ProjectTimeItem {
  return {
    period: new Date(json["period"]),
    activity: ActivityFromJSON(json["activity"]),
    user_id: json["user_id"],
    user_login: json["user_login"],
    spent_time: json["spent_time"],
  };
}
